import { FC, useEffect } from "react"
import Prism from "prismjs"
import "prismjs/themes/prism-okaidia.css"

type Props = {
  code: string
  language: "javascript" | "html"
}

const Code: FC<Props> = ({ code, language }) => {
  useEffect(() => {
    Prism.highlightAll()
  }, [code])

  return (
    <pre>
      <code children={code} className={`language-${language}`} />
    </pre>
  )
}

export default Code
